// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"96d56bab","787":"4134b468","806":"7ae99cb1","959":"51b55ed4"}[chunkId] + ".chunk.js";
};